export default "__VITE_ASSET__CIj2O3LM__"